/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  HOME_BLUE_ICON,
  HOME_GREY_ICON,
  QR_GREY_ICON,
  INVOICE_GREY_ICON,
  ALERTS_GREY_ICON,
  MIS_GREY_ICON,
  MIS_BLUE_ICON,
  ALERTS_BLUE_ICON,
  INVOICE_BLUE_ICON,
  QR_BLUE_ICON,
} from '../../../constants/urls';
import './navBar.css';
import { NavItemText, NavBar } from './styles';
import { useGlobalState } from '../../context/qrState';
import { track } from '../../../analytics/analytics';
import { EventIDs } from '../../../analytics/events';
import { UserContext } from '../../context/userContext';

const NavigationBar = () => {
  const history = useHistory();
  const [activeNavItem, setActiveNavItem] = useGlobalState('isActive');
  const [pageNumber, setPageNumber] = useGlobalState('pageNumber');
  const { email } = useContext<Record<string, any>>(UserContext);
  const navBarClickHandler = (navItem: string) => {
    const payload = {
      email,
    };
    setActiveNavItem(navItem);
    if (navItem === 'HOME') {
      track(EventIDs.HOME, payload);
      history.push('/');
    } else if (navItem === 'MIS') {
      track(EventIDs.MIS, payload);
      history.push('/mis');
    } else if (navItem === 'QR') {
      track(EventIDs.QR_CODE, payload);
      history.push('/qr');
    } else if (navItem === 'INV') {
      track(EventIDs.INVOICES, payload);
      history.push('/inv');
      setPageNumber(0);
    } else {
      track(EventIDs.ALERTS, payload);
      history.push('/alerts');
    }
    // @ts-ignore
    document.querySelector(`#${navItem}`)?.classList.add('highlight');
    setTimeout(() => {
      // @ts-ignore
      document.querySelector(`#${navItem}`)?.classList.remove('highlight');
    }, 2000);
  };

  return (
    <NavBar>
      <div
        id="HOME"
        className="NavBar"
        onClick={() => {
          navBarClickHandler('HOME');
        }}
        onKeyDown={() => {
          navBarClickHandler('HOME');
        }}
      >
        <img
          src={
            window.location.pathname === '/' ? HOME_BLUE_ICON : HOME_GREY_ICON
          }
          alt=""
          className="NavImage"
          width="48px"
          height="48px"
        />
        <NavItemText
          color={window.location.pathname === '/' ? '#454ade' : '#92959A'}
        >
          Home
        </NavItemText>
      </div>
      <div
        id="MIS"
        className="NavBar"
        onClick={() => {
          navBarClickHandler('MIS');
        }}
        onKeyDown={() => {
          navBarClickHandler('MIS');
        }}
      >
        <img
          src={
            window.location.pathname === '/mis' ? MIS_BLUE_ICON : MIS_GREY_ICON
          }
          alt=""
          className="NavImage"
          width="48px"
          height="48px"
        />
        <NavItemText
          color={window.location.pathname === '/mis' ? '#454ade' : '#92959A'}
        >
          MIS
        </NavItemText>
      </div>
      <div
        id="QR"
        className="NavBar"
        onClick={() => {
          navBarClickHandler('QR');
        }}
        onKeyDown={() => {
          navBarClickHandler('QR');
        }}
      >
        <img
          src={window.location.pathname === '/qr' ? QR_BLUE_ICON : QR_GREY_ICON}
          alt=""
          className="NavImage"
          width="48px"
          height="48px"
        />
        <NavItemText
          color={window.location.pathname === '/qr' ? '#454ade' : '#92959A'}
        >
          QR Code
        </NavItemText>
      </div>
      <div
        id="INV"
        className="NavBar"
        onClick={() => {
          navBarClickHandler('INV');
        }}
        onKeyDown={() => {
          navBarClickHandler('INV');
        }}
      >
        <img
          src={
            window.location.pathname === '/inv'
              ? INVOICE_BLUE_ICON
              : INVOICE_GREY_ICON
          }
          alt=""
          className="NavImage"
          width="48px"
          height="48px"
        />
        <NavItemText
          color={window.location.pathname === '/inv' ? '#454ade' : '#92959A'}
        >
          Invoices
        </NavItemText>
      </div>
      <div
        id="ALERT"
        className="NavBar"
        onClick={() => {
          navBarClickHandler('ALERT');
        }}
        onKeyDown={() => {
          navBarClickHandler('ALERT');
        }}
      >
        <img
          src={
            window.location.pathname === '/alerts'
              ? ALERTS_BLUE_ICON
              : ALERTS_GREY_ICON
          }
          alt=""
          className="NavImage"
          width="48px"
          height="48px"
        />
        <NavItemText
          color={window.location.pathname === '/alerts' ? '#454ade' : '#92959A'}
        >
          Alerts
        </NavItemText>
      </div>
    </NavBar>
  );
};

export default NavigationBar;
